import { useEffect, useState } from 'react';

export default function Hero() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section id="hero" className="relative w-full h-screen overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/fcec5c0e05a8d52b64b7b21991bc109e.jpg"
          alt="Studio Dissolve Hero"
          className="w-full h-full object-cover object-center"
          onLoad={() => setLoaded(true)}
        />
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60" />
      </div>

      {/* Content — bottom left */}
      <div
        className={`absolute z-10 bottom-0 left-0 w-full px-16 pb-24 transition-all duration-800 ${
          loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
        }`}
      >
        <p className="font-sans-kr text-xs tracking-widest-kr text-white/50 mb-5">
          콘텐츠 프로덕션 스튜디오
        </p>

        <h1 className="font-serif-display text-7xl lg:text-8xl text-white font-light tracking-wide mb-4 leading-none">
          Studio Dissolve
        </h1>

        <p className="font-sans-kr text-sm text-white/60 tracking-wider-kr font-light">
          스토리텔링, 프로덕션, 그리고 디지털 콘텐츠
        </p>
      </div>
    </section>
  );
}
